import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { canEditGlobalCatalog } from '../../../features/auth/admin-capabilities';
import { useAuth } from '../../../features/auth/auth-context';
import { DeleteServiceCategoryDialog } from '../../../features/service-categories/components/delete-service-category-dialog';
import { ServiceCategoryForm } from '../../../features/service-categories/components/service-category-form';
import { serviceCategoryByIdOptions } from '../../../features/service-categories/queries';
import { PageHeader } from '../../../shared/components/page-header';
import { SuperadminCatalogNotice } from '../../../shared/components/superadmin-catalog-notice';

export const Route = createFileRoute('/_authenticated/service-categories/$categoryId')({
  staticData: { breadcrumb: 'Редактирование' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(serviceCategoryByIdOptions(params.categoryId)),
  component: EditServiceCategoryPage,
});

function EditServiceCategoryPage() {
  const router = useRouter();
  const { categoryId } = Route.useParams();
  const { data: category } = useSuspenseQuery(serviceCategoryByIdOptions(categoryId));
  const { adminRoles } = useAuth();
  const canEdit = canEditGlobalCatalog(adminRoles);

  return (
    <div>
      {!canEdit && <SuperadminCatalogNotice />}
      <PageHeader
        title={category.name}
        description={`slug: ${category.slug}`}
        actions={
          canEdit ? (
            <DeleteServiceCategoryDialog
              category={category}
              onDeleted={() => router.navigate({ to: '/service-categories' })}
            />
          ) : null
        }
      />
      <ServiceCategoryForm mode="edit" category={category} readOnly={!canEdit} />
    </div>
  );
}
